import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import LazyImage from './LazyImage';

export function PreloadedImage({
  className,
  src,
  imageSource,
  alt,
  loadedCallback,
  errorCallback,
}) {
  return (
    <LazyImage
      className={className}
      src={imageSource || src}
      alt={alt}
      loadedCallback={loadedCallback}
      errorCallback={errorCallback || loadedCallback}
    />
  );
}

PreloadedImage.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  src: PropTypes.string,
  imageSource: PropTypes.string,
  loadedCallback: PropTypes.func,
  errorCallback: PropTypes.func,
};

// Because this is used in the CompDisplay which has a fixed aspect ratio, 100% width & height are appropriate.
export const FullStretchPreloadedImage = styled(PreloadedImage)`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
`;

export default PreloadedImage;
